import * as React from "react"
import { createRoot } from "react-dom/client"
import "../toolkit/tokens.css"
import "./portal.css"
import "./nav.css"
import "./studio/studio.css"
import { App } from "./App"

createRoot(document.getElementById("main")!).render(<App />)
